export const ACCEPT_TYPES = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
